import { useMutation } from 'react-query';
import { baseErrorHandler } from '../../../queries/baseErrorHandler';
import { showMessage } from '../../../queries/showMessage';
import { $api } from '../../../service/RequestService';
import { endPoints } from '../utils/constants/endPoints';

export function useClientSendMessage() {
  return useMutation(
    async (data: { clientId: number; text: string }) => {
      const res = await $api.post(endPoints.CLIENT_SEND_MESSAGE, data);
      return res.data;
    },
    {
      onSuccess: data => {
        showMessage(data.message, data.accept);
      },
      onError: baseErrorHandler
    }
  );
}
